import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/dialpad-ai-color-reversed.vue
var s = {
	name: "DtIconDialpadAiColorReversed",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["fill"], d = ["id"], f = ["id"];
function p(e, t, n, s, p, m) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([m.iconSizeClass, "d-icon d-icon--dialpad-ai-color-reversed"]),
		"data-qa": m.dataQA,
		"aria-hidden": m.ariaHidden,
		role: "img",
		"data-name": "Dialpad Ai Color Reversed",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [i("path", {
		d: "M0 5.301A5.301 5.301 0 0 1 5.301 0h13.398A5.301 5.301 0 0 1 24 5.301v13.398A5.301 5.301 0 0 1 18.699 24H5.301A5.301 5.301 0 0 1 0 18.699V5.301Z",
		fill: `url(#${e.uniqueID}b)`
	}, null, 8, u), t[0] || (t[0] = i("path", {
		d: "M19.725 7.634c0 .693-.585 1.255-1.307 1.255s-1.307-.562-1.307-1.255c0-.693.585-1.255 1.307-1.255s1.307.562 1.307 1.255ZM8.856 9.142c.27-.88.787-1.166 1.088-1.166.301 0 .817.285 1.087 1.162v.001l1.964 6.332v.002c.417 1.35 1.503 2.626 3.071 2.626a3.41 3.41 0 0 0 3.41-3.41v-4.335a1.038 1.038 0 0 0-2.075 0v4.336c0 .737-.598 1.334-1.335 1.334-.3 0-.817-.286-1.087-1.163l-1.964-6.333C12.598 7.177 11.512 5.9 9.943 5.9c-1.57 0-2.657 1.28-3.072 2.632v.002l-2.55 8.22a1.038 1.038 0 0 0 1.982.615l2.551-8.226v-.001Z",
		fill: "#fff"
	}, null, -1))], 8, l), i("defs", null, [i("linearGradient", {
		id: `${e.uniqueID}b`,
		x1: "25.431",
		y1: "23.998",
		x2: "10.959",
		y2: "-6.687",
		gradientUnits: "userSpaceOnUse"
	}, [...t[1] || (t[1] = [
		i("stop", {
			offset: ".297",
			"stop-color": "#7C52FF"
		}, null, -1),
		i("stop", {
			offset: ".762",
			"stop-color": "#F9008E"
		}, null, -1),
		i("stop", {
			offset: "1",
			"stop-color": "#F6AB3C"
		}, null, -1)
	])], 8, d), i("clipPath", { id: `${e.uniqueID}a` }, [...t[2] || (t[2] = [i("path", {
		fill: "#fff",
		d: "M0 0h24v24H0z"
	}, null, -1)])], 8, f)])], 10, c);
}
var m = /* @__PURE__ */ n(s, [["render", p]]);
//#endregion
export { m as default };

//# sourceMappingURL=dialpad-ai-color-reversed.js.map